import { useContext } from "react";

import { StoreContext } from "components/store-provider";

export function useAppDispatch() {
  const [, dispatch] = useContext(StoreContext);
  return dispatch;
}
